<template>
    <Modal v-model="show" :title="modalTitle" :mask-closable="false" width="600" @on-cancel="modalCancel">
        <div class="appointment-time-wrapper">
            <div class="box appointment-time" v-for="(item, index) in appointmentTime" v-if="item.id > -1">
                <div>
                    {{ item.beginTime }}-{{ item.endTime
                    }}&nbsp;&nbsp;&nbsp;限制:<span class="text">{{ item.limitCount }}</span> 人</div>
                <div class="iconfont icon-bianji edit-icon" @click="editTime(item, index)"></div>
                <div class="iconfont icon-quxiao1 del-icon" @click="delTime(item,index)"></div>
            </div>
        </div>
        <Button class="btn" type="primary" @click="addTime('edit')">添加</Button>
        <div slot="footer" class="box" style="justify-content: flex-end">
            <Button type="text" @click="modalCancel">取消</Button>
            <Button type="primary" @click="confirmTime">保存</Button>
        </div>
    </Modal>
</template>
  
<script>
export default {
    props: {
        modalTitle: {
            type: String,
            default: '预约时间'
        },
        showModel: {
            default: false,
            type: Boolean
        },
        appointmentTime: {
            default: [],
            type: Array
        },
        timeItem: null,
    },
    name: 'timeModal',
    data() {
        return {
            show: false,
            info: {
                beginWeekValue: '',
                endWeekValue: '',
                beginTime: '',
                endTime: '',
                limitCount: ''
            },
        }
    },
    watch: {
        showModel() {
            this.show = this.showModel
        },
        timeItem() {
            if (!_.isEmpty(this.timeItem)) this.info = JSON.parse(JSON.stringify(this.timeItem))
        }
    },
    methods: {
        addTime() {
            console.log(this)
            this.$parent.timeIndex = -1
            this.$parent.SpecialTimeItem = {}
            this.$parent.showSpecialDateModal = true
        },
        editTime(data, index) {
            this.$parent.timeIndex = index
            this.$parent.SpecialTimeItem = data
            this.$parent.showSpecialDateModal = true
        },
        delTime(data,index) {
            let num = this.$parent.appointmentTimeList[index].id
            if(num){
                this.$parent.appointmentTimeList[index].id = 0 - num 
            } else {
                this.$parent.appointmentTimeList.splice(index, 1)
            }
        },
        modalCancel() {
            this.$emit('closeModal')
        },
        changeStart(e) {
            this.info.beginTime = e
        },
        changeEnd(e) {
            this.info.endTime = e
        },
        confirmTime() {
            this.$emit('handleTimeSave')
        },
    }
}
</script>
  
<style scoped lang="less">
.mar-btm {
    margin-bottom: 20px;
}

.v_center {
    align-items: center;
}

.label {
    width: 60px;
    text-align: right;
}

.limit-label {
    width: 60px;
    margin-left: 5px;
    margin-right: 5px;
}

.limit-input {
    display: flex;
    width: 86%;
    align-items: center;
}

.person {
    width: 5%;
    text-align: right;
}

.content-box {
    font-size: 14px;
    padding-bottom: 30px;

    .item-wrapper {
        align-items: center;
    }

    .name {
        width: 60px;
        margin-right: 20px;
        text-align: right;
    }

    .input {
        /*width: 160px;*/
        margin: 0 10px
    }

    .pic-box {
        align-items: center;
        flex-wrap: wrap;
    }

    .pic-wrapper {
        height: 40px;
        width: 40px;
        position: relative;
        margin-right: 20px;
        margin-bottom: 20px;

        .select-pic {
            height: 15px;
            width: 15px;
            position: absolute;
            top: -7px;
            right: -7px;
        }

        .pic {
            height: 100%;
            width: 100%;
        }
    }
}
</style>
  